const currentYear = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="bg-[#080808] border-t border-white/5 py-12 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/377371b4-550c-49ea-87b3-851d396b54a6.png"
                alt="JEKO Logo"
                className="w-8 h-8 object-contain"
              />
              <span className="text-white font-semibold text-base">JEKO, d.o.o.</span>
            </div>
            <p className="text-gray-500 text-xs leading-relaxed max-w-xs">
              Developing modern, privacy-first applications for the iOS platform.
              Based in Jesenice, Slovenia.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold text-xs uppercase tracking-widest mb-4">
              Products
            </h4>
            <ul className="space-y-2">
              <li className="text-gray-500 text-sm">JEKO VPN</li>
              <li className="text-gray-500 text-sm">JEKO Cleaner</li>
            </ul>
          </div>

          {/* Contact summary */}
          <div>
            <h4 className="text-white font-semibold text-xs uppercase tracking-widest mb-4">
              Contact
            </h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li>
                <span className="text-gray-600 text-xs uppercase tracking-wider mr-2">Address:</span>
                Cesta marsala Tita 51
              </li>
              <li>
                <span className="text-gray-600 text-xs uppercase tracking-wider mr-2">City:</span>
                Jesenice
              </li>
              <li>
                <span className="text-gray-600 text-xs uppercase tracking-wider mr-2">Zip:</span>
                4270
              </li>
              <li>
                <span className="text-gray-600 text-xs uppercase tracking-wider mr-2">Country:</span>
                Slovenia
              </li>
              <li>
                <span className="text-gray-600 text-xs uppercase tracking-wider mr-2">Email:</span>
                help@jekodoo.com
              </li>
              <li>
                <span className="text-gray-600 text-xs uppercase tracking-wider mr-2">Phone:</span>
                +1 8383323360
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">
            &copy; {currentYear} JEKO, d.o.o. All rights reserved.
          </p>
          <p className="text-gray-700 text-xs">
            iOS App Development &bull; Jesenice, Slovenia
          </p>
        </div>
      </div>
    </footer>
  );
}
